import { createNodeDef } from "../nodes.helpers";

export const nullNodeDef = createNodeDef({
  type: "staticNull",
  displayName: "null (static)",
  shortDisplayName: "null",
  initialData: () => ({}),
  generate: () => null,
});
